import React from 'react';
import { Bar } from 'react-chartjs-2';

const COLORS = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899'];

const ItemCategoryMix = ({ data }) => {
    if (!data || data.length === 0) return null;

    const labels = data.map(c => c.category_name);
    const values = data.map(c => c.revenue);
    const colors = labels.map((_, i) => COLORS[i % COLORS.length]);

    const chartData = {
        labels,
        datasets: [{
            label: 'Revenue (BHD)',
            data: values,
            backgroundColor: colors,
            borderRadius: 4,
        }],
    };

    const options = {
        responsive: true,
        indexAxis: 'y',
        plugins: {
            legend: { display: false },
        },
        scales: {
            x: {
                title: { display: true, text: 'Revenue (BHD)' },
            },
        },
    };

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">Item Category Mix</h6>
                <Bar data={chartData} options={options} />
                <div className="table-responsive mt-3">
                    <table className="table table-sm table-bordered mb-0">
                        <thead className="table-light">
                            <tr>
                                <th>Category</th>
                                <th className="text-end">Revenue</th>
                                <th className="text-end">Items</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((c, i) => (
                                <tr key={i}>
                                    <td>{c.category_name}</td>
                                    <td className="text-end">{c.revenue?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                    <td className="text-end">{c.item_count}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ItemCategoryMix;
